module.exports = __webpack_public_path__ + "static/frontier_middle.249a3d3a.png";